// extracted by mini-css-extract-plugin
export var active = "SpecialCursor-module--active--48361";
export var canvas = "SpecialCursor-module--canvas--39472";
export var changeless = "SpecialCursor-module--changeless--abb2e";
export var wrapper = "SpecialCursor-module--wrapper--6e7cc";